import Vue from 'vue'
import Vuex from 'vuex'

import { Theme } from '@/models'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    themes: [],
    lastId: -1,
    idActive: -1,
    questions: ["Vilka nyheter läser du?","Hur skiljer sig avsändarnas rapportering åt?","Hur påverkas du av nyheterna?","Vilka ämnen skrivs det mycket om?","Skriver avsändarna om samma nyheter?","Rapporterar avsändarna lika kring samma nyhet?","Vilka perspektiv har de olika avsändarna?","Hur skiljer sig avsändarnas bildspråk åt?"]
  },
  mutations: {
    add(state,payload){
      let theme = payload.theme;
      Vue.set(state.themes,theme.id,theme);
      state.lastId = theme.id;
    },
    setId(state,payload){
      Vue.set(state,'idActive',payload.id);
    },
    setIdByRoute(state,payload){
      let theme = state.themes.find(t => t.route == payload.route);
      Vue.set(state,'idActive',theme.id);
    }
  },
  actions: {
    createAndAdd({state,commit,dispatch},payload) {
      let t = new Theme();
      t.name = payload.theme.name;
      t.route = payload.theme.route;
      t.questions = state.questions.concat(payload.theme.questions);
      t.id = state.lastId+1;
      commit('add', {theme: t});
      payload.theme.chambers.forEach((c) => {
        dispatch('chambers/createAndAdd',{chamber: c, idTheme: t.id}, {root: true})
      });
    },
  },
  getters: {
    getAll: (state) => {
      return state.themes;
    },
    getActive: (state) => {
      return state.idActive > -1 ? state.themes[state.idActive] : null;
    },
    getThemeById: (state) => (id) => {
      return state.themes.find(t => t.id == id);
    },
    getThemeByRoute: (state) => (route) => {
      return state.themes.find(t => t.route == route);
    },
  },
  modules: {
  }
}
